var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy"}],staticClass:"more"},[_c('Card',{staticClass:"shadow-2"},[_c('template',{slot:"content"},[_c('p',[_vm._v("More is Coming...")])])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }